module.exports = __webpack_public_path__ + "0ea36aec89d8585b509956af24682559.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/o_shares_investments.png
// module id = 1896
// module chunks = 0